<!-- @Version 1.0.1 -->
<div class="row">
   <p data-testid="text" [style.text-align]="fieldItem.attribute_2 | posAndColor : 1 : POSITION.LEFT" [attr.color]="fieldItem.attribute_1 | posAndColor : 2 : COLOR.TEXT" [innerHTML]="fieldItem.attribute_3"></p>
</div>
